import ConfirmationDialog from 'components/ReusableComponents/ConfirmationDialog'

import styles from '../MultiStepPMSLogin.module.scss'

const ProcessConfirmationDialog = ({
  success,
  info,
  handleSubmit,
  handleClose,
  shouldFinalizeConfiguration
}) => {
  const ohipOriginSuccess = success && shouldFinalizeConfiguration
  return (
    <ConfirmationDialog
      title={success ? 'Got the data from OHIP' : 'Failed to get the data from OHIP'}
      positiveMessage={ohipOriginSuccess ? 'Yes' : false}
      negativeMessage={ohipOriginSuccess ? 'No' : 'Close'}
      hasConfirmButton={ohipOriginSuccess ? true : false}
      onConfirm={() => handleSubmit()}
      onClose={handleClose}
    >
      <div className={styles.container}>
        {info ? (
          <>
            <p className={styles.infoText}>
              <span className={styles.textBold}>{info.hotelName}</span>
              <br />
              <span className={styles.textBold}>{info.inHouseGuestCount}</span> in-house
              guests
            </p>
            {ohipOriginSuccess ? (
              <p className={styles.checkMessage}>Is this information correct?</p>
            ) : (
              <p className={styles.checkMessage}>
                Please contact to engineering team to complete the process.
              </p>
            )}
          </>
        ) : (
          <p className={styles.phoneLabel}>
            Make sure the property id is correct and try again.
          </p>
        )}
      </div>
    </ConfirmationDialog>
  )
}

export default ProcessConfirmationDialog
